import pegasus from "./01-pegasus.js";

// Check if text is overflowing
function isTextOverflowing(element) {
  return (
    element.scrollWidth > element.clientWidth ||
    element.scrollHeight > element.clientHeight
  );
}

//Init cloudflare email decoder (Cloudflare obfuscates emails for protection)
document.addEventListener("DOMContentLoaded", function () {
  pegasus.decodeAllCloudflareEmails();

  // Check if heading is overflowing and add .responsive-heading
  document.querySelectorAll(".js-is-text-overflowing").forEach((element) => {
    if (isTextOverflowing(element)) {
      element.classList.remove("has-x-large-font-size");
      element.classList.add("responsive-heading");
    }
  });
});

// YOAST FAQ functionality
document.addEventListener("DOMContentLoaded", function () {
  const yoastSchemaSection = document.querySelector(
    ".wp-block-yoast-faq-block"
  );

  if (!yoastSchemaSection) return;

  const schemaQuestions = yoastSchemaSection.querySelectorAll(
    ".schema-faq-section .schema-faq-question"
  );

  schemaQuestions.forEach((question) => {
    question.addEventListener("click", function (event) {
      event.stopPropagation(); // Prevent event bubbling

      const answer = this.nextElementSibling;
      const allAnswers = document.querySelectorAll(".schema-faq-answer");

      allAnswers.forEach((ans) => {
        if (ans !== answer && ans.classList.contains("active")) {
          ans.style.height = "0px";
          ans.classList.remove("active");
          ans.previousElementSibling.classList.remove("active");
        }
      });

      if (answer.classList.contains("active")) {
        answer.style.height = "0px";
        answer.classList.remove("active");
        question.classList.remove("active");
      } else {
        answer.classList.add("active");
        question.classList.add("active");
        answer.style.height = "auto";
      }
    });
  });
});
